export default {
	getCompanyByID: (state) => (id) => {
		// console.log('getter - getCompanyByID',id,state.companies.find(company => company.id === id))
		return state.companies.find(company => company.id === id)
	},
	getCategoryById: (state) => (id) => {
		return state.categories.find(category => category.id === id)
	},
	getCriteriaById: (state) => (id) => {
		return state.criterias.find(criteria => criteria.id === id)
	},
	getCompaniesByLanguage: (state) => (lang) => {
		return state.companies.filter(company => company.language === lang)
	},
	getCompaniesBySeason: (state) => (season) => {
		return state.companies.filter(company => company.season === season )
	},
	getCompaniesByCategory: (state) => (catName) => {
		return state.companies.filter(company => company.category === catName)
	},
	getSalespointByID: (state) => (id) => {
		return state.salespoints.find(sale => sale.id === id)
	},
	getCardInfoByID: (state) => (id) => {
		return state.cardinfos.find(cardInfo => cardInfo.id === id)
	},
	getNewsByID: (state, getters) => (id) => {
		let filteredNews = getters.getCurrentNews.filter(el => el.id === id)
		if (filteredNews.length === 1) {
			return filteredNews[0]
		}
		return null
	},
	hasCompanyAlreadyLiked: (state) => (id) => {
		return state.likedCompanies.includes(id)
	},
	getBookmarks: (state, getters) => {
		let bookmarks = [];
		// console.log('getter getBookmarks', state.bookmarks);
		state.bookmarks.forEach(bookmarkObject => {
			if (bookmarkObject.type === 'company') {
				let company = getters.getCompanyByID(bookmarkObject.id)
				if (company) {
					company = Object.assign(company, { bmType: 'company' })
					bookmarks.push(company)
				}
			} else if (bookmarkObject.type === 'salespoint') {
				let salespoint = getters.getSalespointByID(bookmarkObject.id)
				if (salespoint) {
					salespoint = Object.assign(salespoint, { bmType: 'salespoint' })
					bookmarks.push(salespoint)
				}
			}
		})
		return bookmarks
	},
	getBookmarksBlank: (state) => {
		return state.bookmarks
	},
	getCurrentCompanies: (state) => {
		return state.companies
			.filter(company => company.language === state.language)
			.filter(company => company.season === state.season)
			.filter(company => {
				if (company.designation !== undefined) {
					return company.designation.includes('Ausflugsziel')
				} else {
					return true
				}
			})
	},
	getCurrentBonusClubCompanies: (state) => {
		return state.companies
			.filter(company => company.language === state.language)
			.filter(company => company.season === state.season)
			.filter(company => {
				if (company.designation !== undefined) {
					return company.designation.includes('Bonuspartner')
				} else {
					return false
				}
			})
	},
	getCurrentSalespoints: (state) => {
		return state.salespoints.filter(sale => sale.language === state.language).filter(sale => sale.season === state.season)
	},
	getCurrentNews: (state) => {
		return state.news.filter(news => news.language === state.language).filter(news => news.season === state.season)
	},
	getCurrentCardinfos: (state) => {
		return state.cardinfos.filter(infos => infos.language === state.language).filter(infos => infos.season === state.season)
	},
	getCurrentCriterias: (state) => {
		return state.criterias.filter(criteria => criteria.language === state.language).filter(criteria => criteria.season === state.season)
	},
	getCurrentCategories: (state) => {
		return state.categories.filter(cat => cat.language === state.language).filter(cat => cat.season === state.season)
	},
	getCurrentBonusCategories: (state) => {
		return state.bonusCategories.filter(cat => cat.language === state.language).filter(cat => cat.season === state.season)
	},
	getCurrentBookmarks: (state, getters) => {
		// console.log('getCurrentBookmarks', getters.getBookmarks);
		return getters.getBookmarks.filter(company => company.language === state.language).filter(company => company.season === state.season)
	},
	getCardInfoPageByName: (state, getters) => (pagename) => {
		let array = getters.getCurrentCardinfos.filter(page => page.type === pagename)
		if (array.length == 1) {
			return array[0]
		}
		return null
	},
	getNearbyCompanies: (state, getters) => (range = 50000) => {
		let sortedCompanies = getters.getCurrentCompanies.sort((a, b) => {
			// check if properties exist
			if (a.distance && b.distance) {
				if (a.distance < b.distance) {
					return -1
				}
				if (a.distance > b.distance) {
					return 1
				}

				return 0
			}

			// if props don't exists order items at last
			return 1
		})

		return sortedCompanies.filter(el => {
			return el.distance <= range
		})
	},
	getCards: (state) => {
		return state.cards
	},
	getFilteredResultsCount: (state) => (entity) => {
		return state.activeFilters[entity].resultsCount
	},
	getFilteredResults: (state) => (entity) => {
		return state.activeFilters[entity].results
	},
	getSelectedRange: (state) => (entity) => {
		return state.activeFilters[entity].selectedRange
	},
	getSelectedCategories: (state, getters) => (entity) => {
		let selectedCategories = []
		state.activeFilters[entity].selectedCategories.forEach((id) => {
			let cat = getters.getCategoryById(id)
			if (cat !== undefined) {
				selectedCategories.push(cat)
			}
		})
		return selectedCategories
	},
	getSelectedCriterias: (state, getters) => (entity) => {
		let selectedCriterias = []
		state.activeFilters[entity].selectedCriterias.forEach((id) => {
			let criteria = getters.getCriteriaById(id)
			if (criteria !== undefined) {
				selectedCriterias.push(criteria)
			}
		})
		return selectedCriterias
	},
	getTopPerformanceState: (state) => (entity) => {
		return state.activeFilters[entity].onlyTopPerformance
	},
}
